import { render, staticRenderFns } from "./SelectExpedition.vue?vue&type=template&id=701ddc62&"
import script from "./SelectExpedition.vue?vue&type=script&lang=ts&"
export * from "./SelectExpedition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701ddc62')) {
      api.createRecord('701ddc62', component.options)
    } else {
      api.reload('701ddc62', component.options)
    }
    module.hot.accept("./SelectExpedition.vue?vue&type=template&id=701ddc62&", function () {
      api.rerender('701ddc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectExpedition.vue"
export default component.exports